import type { DataTableSelectEvent } from "primereact/datatable";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TableWidget from "../../../widgets/table/tableWidget/TableWidget";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import { rosreestrLayersSettings } from "../../../widgets/map/mapFeatures/mapFunctions/rosreestrFunctions/rosreestrFunctions";
import { rosreestrObjectsTableColumns } from "./rosreestrObjectsTableColumns";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { defineTableFilters } from "../../../widgets/table/tableFeatures/tableFunctions";
import LoaderWrapper from "../../../widgets/loaderWrapper/LoaderWrapper";

export default function TableRosreestrObjects() {
    const navigate = useNavigate()
    const { categoryId, subcategoryId }: any = useParams();
    const [tableName, setTableName] = useState<string>('');
    const [columns, setColumns] = useState<any>(null)
    const [tableValue, setTableValue] = useState<any>([])
    const [tableState, setTableState] = useState<any>(null)

    const selectedRosreestrObjectsByGroupId = useAppSelector(state => state.rosreestr.selectedRosreestrObjectsByGroupId)

    function onRowSelect(event: DataTableSelectEvent) {
        const objectId = event?.data?.objectId
        navigate(`/app/rosreestrObjects/${categoryId}/${subcategoryId}/${objectId}`)
    }

    useEffect(() => {
        const layerSettingsFilter = ({ objectsCategoryId, objectsSubcategoryId }: any) => objectsCategoryId === categoryId && objectsSubcategoryId === subcategoryId
        const [layerIndex, rosreestrLayerSettings]: any = Object.entries(rosreestrLayersSettings).find(([layerIndex, layerSettings]) => layerSettingsFilter(layerSettings))
        const { caption, groupId } = rosreestrLayerSettings
        if (caption) {
            setTableName(caption)
        }
        const selectedRosreestrObjects = selectedRosreestrObjectsByGroupId?.[groupId]?.[categoryId]?.[subcategoryId]
        if (selectedRosreestrObjects) {
            setTableValue(selectedRosreestrObjects)
        }
        const columns = rosreestrObjectsTableColumns?.[layerIndex]
        if (columns) {
            setColumns(columns)
        }
        let filters = defineTableFilters(columns)
        const tableState = { filters }
        setTableState(tableState)
    }, [categoryId, subcategoryId, selectedRosreestrObjectsByGroupId])

    return (
        <>
            <ContentHeader title={tableName} />
            <div className="table-widget-with-toast with-content-header">
                <LoaderWrapper isLoading={!tableValue} >
                    <TableWidget
                        tableValue={tableValue}
                        tableState={tableState}
                        columns={columns}
                        onRowSelect={onRowSelect}
                    />
                </LoaderWrapper>
            </div >
        </>
    )
}

